import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import get from 'lodash/get';
import moment from 'moment-timezone';
import { Aggregators } from '../utils/aggregator';
const parseApi = require('../../../../helpers/json-api-parser').default;

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export const queryAllSessionEvents = createAsyncThunk('sessions/queryAllSessionEvents', async (dateParams, thunkAPI) => {
    try {
        const response = await axios.get(`${API_BASE}/analytics/`, { params: dateParams });
        return response.data;
    } catch (err) {
        return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
});

export const loadStations = createAsyncThunk('sessions/loadStations', async (aggregator, thunkAPI) => {
    try {
        let query = '';
        if (aggregator && aggregator !== Object.keys(Aggregators).find(k => Aggregators[k] === Aggregators.singleAndMultiStation)) {
            query = `?filter=${encodeURIComponent(JSON.stringify({ stationGroup: aggregator }))}`;
        }
        const response = await axios.get(`${API_BASE}/users/list${query}`);
        // Normalize the response
        const normalizedData = await parseApi(response.data);
        return normalizedData;
    } catch (err) {
        return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
});

export const loadData = createAsyncThunk('sessions/loadData', async (newDateParams, thunkAPI) => {
    thunkAPI.dispatch(changeDateParams(newDateParams));
    await thunkAPI.dispatch(queryAllSessionEvents(newDateParams));
    await thunkAPI.dispatch(loadStations(newDateParams.aggregator));
    return newDateParams;
});

const initialState = {
    dateParams: {
        dateRange: 'month',
        startDate: moment().subtract(7, 'day').toISOString(),
        endDate: moment().toISOString(),
        aggregator: '',
        platform: 'all',
    },
    allSessionEvents: {},
    stations: {},
    error: false,
    loadingAllSessionEvents: false,
};

const sessionsSlice = createSlice({
    name: 'sessions',
    initialState,
    reducers: {
        changeDateParams(state, action) {
            const { startDate, endDate, ...rest } = action.payload;
            state.dateParams = {
                ...rest,
                startDate: startDate ? new Date(startDate).toISOString() : undefined,
                endDate: endDate ? new Date(endDate).toISOString() : undefined,
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(queryAllSessionEvents.pending, (state) => {
                state.loadingAllSessionEvents = true;
            })
            .addCase(queryAllSessionEvents.fulfilled, (state, action) => {
                state.loadingAllSessionEvents = false;
                state.allSessionEvents = action.payload;
            })
            .addCase(queryAllSessionEvents.rejected, (state, action) => {
                state.loadingAllSessionEvents = false;
                state.error = action.payload || true;
            })
            .addCase(loadStations.fulfilled, (state, action) => {
                state.stations = get(action.payload, 'entities.users');
            })
            .addCase(loadStations.rejected, (state, action) => {
                // leave state unchanged
            })
            .addCase(loadData.fulfilled, (state, action) => {
                state.lastUpdated = moment().toISOString();
            });
    },
});

export const { changeDateParams } = sessionsSlice.actions;
export default sessionsSlice.reducer;

export const selectDateParams = (state) => state.sessions.dateParams;
export const selectAllSessionEvents = (state) => state.sessions.allSessionEvents;
export const selectLoadingAllSessionEvents = (state) => state.sessions.loadingAllSessionEvents;
export const selectStations = (state) => state.sessions.stations;
export const selectError = (state) => state.sessions.error; 